var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.creating_member)?_c('div',[_vm._v(" "+_vm._s(_vm.$t('MEMBER.CREATE_BEFORE_EDIT'))+" ")]):_c('FamilyTable',{attrs:{"me":_vm.member,"settings":_vm.familySettings,"member":_vm.member},on:{"on_family_data_changed":_vm.on_family_data_changed}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }